//imports
import {
    DASHBOARD_PANEL_SHARE_OPEN_MODAL,
    DASHBOARD_PANEL_SHARE_REQUEST,
    DASHBOARD_PANEL_SHARE_RESULT,
    DASHBOARD_PANEL_GET_DASHBOARD_REQUEST,
    DASHBOARD_PANEL_GET_DASHBOARD_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    info: null,
    dashboard: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case DASHBOARD_PANEL_GET_DASHBOARD_REQUEST:
            return { ...state, loading: true }
        case DASHBOARD_PANEL_GET_DASHBOARD_RESULT:
            return { ...state, loading: false, info: action.payload }
        case DASHBOARD_PANEL_SHARE_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, dashboard: action.payload.data }

        case DASHBOARD_PANEL_SHARE_REQUEST:
            return { ...state, loading: true }

        case DASHBOARD_PANEL_SHARE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DASHBOARD_PANEL_SHARE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};